import { Fragment, useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { FaCheck } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import Loading from "../../../../components/Loading";
import PaginateCard from "../../../../components/PaginateCard";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import { getByAuthService } from "../../../../function/helper";
import dateTimeToJalali from "../../../../function/jalali/dateTimetoJalali";
import WalletFormRequest from "./components/WalletFormRequest";

function WalletRequest() {
  const ref = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [showFormRequest, setShowFormReqeust] = useState(false);
  const [requests, setRequests] = useState([]);
  const [paginate, setPaginate] = useState({
    page: 1,
    items: 10,
  });
  const [count, setCount] = useState(0);

  const getData = async () => {
    setIsLoading(() => true);
    const response = await getByAuthService(
      "/myaccount/v1/codrequest/get-requests",
      paginate
    );

    if (response.status === 200) {
      setRequests(response.data.result.items);
      setCount(response.data.result.count);
    }

    setIsLoading(() => false);
  };

  useEffect(() => {
    getData();
  }, [paginate.page]);

  return (
    <div>
      <h4 className="text-secondary mt-5" ref={ref}>
        درخواست های COD/برداشت از کیف پول
      </h4>
      <hr />

      <div className="mt-2 mb-4">
        <button
          className="btn btn-primary"
          onClick={() => setShowFormReqeust(() => true)}
        >
          درخواست جدید
        </button>
      </div>

      <div className="my-5 w-100 px-1 overflow-x-auto">
        <Table striped={true} bordered={true}>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره درخواست</th>
              <th>
                <span>مبلغ درخواستی </span>
                <small>(ریال)</small>
              </th>
              <th>شماره سفارش</th>
              <th style={{ minWidth: 110 }}>فرستنده</th>
              <th>تاریخ</th>
              <th>شماره شبا</th>
              <th>نام بانک</th>
              <th>توضیحات</th>
              <th style={{ minWidth: 120 }}>وضعیت</th>
            </tr>
          </thead>
          <tbody>
            {isLoading === true && (
              <tr>
                <td colSpan="9">
                  <Loading />
                </td>
              </tr>
            )}
            {isLoading === false &&
              requests.map((item, idx) => (
                <tr key={item.id} className="align-middle">
                  <td>{idx + 1 + (paginate.page - 1) * paginate.items}</td>
                  <td>{item.id}</td>
                  <td>{item.requested_amount.toLocaleString()}</td>
                  <td>
                    <PrintLink ids={[item.numberParcel]} byNumberParcel>
                      {item.numberParcel}
                    </PrintLink>
                  </td>
                  <td>
                    {item.total_post?.source?.type === 0 ? (
                      <Fragment>
                        <span>{item.total_post?.source?.name}</span>
                        <span> {item.total_post?.source?.family}</span>
                      </Fragment>
                    ) : (
                      <span>{item.total_post?.source?.compony}</span>
                    )}
                  </td>
                  <td>{dateTimeToJalali(item.created_at).date}</td>
                  <td>{item.bank_account.shabaNumber}</td>
                  <td>{item.bank_account.bankName}</td>
                  <td>{item.description}</td>
                  <td>
                    {item.status === 0 && (
                      <div className="text-success">
                        <span>پرداخت شده</span>
                        <span className="me-1">
                          <FaCheck />
                        </span>
                      </div>
                    )}

                    {item.status === 1 && (
                      <div className="text-primary">در دست اقدام</div>
                    )}

                    {item.status === 2 && (
                      <div className="text-danger fs-5">
                        <span>رد شده</span>
                        <span className="me-1">
                          <MdCancel />
                        </span>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <PaginateCard
        count={count}
        numberItems={paginate.items}
        numberPage={paginate.page}
        onIndexChoose={page => {
          setPaginate(cur => ({ ...cur, page }));
          ref.current?.scrollIntoView({ behavior: "instant" });
        }}
      />

      {showFormRequest === true && (
        <WalletFormRequest
          onClose={() => setShowFormReqeust(() => false)}
          onSubmit={getData}
        />
      )}
    </div>
  );
}

export default WalletRequest;
